export default "﻿<div>\n    <div data-dojo-attach-point=\"tableContainer\"></div>\n</div>\n"